import {
    PAY_ORDER_SUCCESS,
    PAY_ORDER_FAILED,
    PAY_ORDER_INVALID_REQUEST,
    PAY_ORDER_INVALID_CUSTOMER_ID,
    PAY_ORDER_INVALID_WALLET_OWNER_ID,
    PAY_ORDER_INVALID_AMOUNT,
    PAY_ORDER_ACCOUNT_NOT_EXISTS,
    PAY_ORDER_INSUFFICIENT_AMOUNT,
    PAY_ORDER_INVALID_INTEGRATION,
    PAY_ORDER_INVALID_TELCC,
    PAY_ORDER_INVALID_PHONE,
    PAY_ORDER_INVALID_NAME,
    PAY_ORDER_OPERATION_NOT_PERMITTED,
    RESET_PAY_ORDER,
    LOADING_PAY_ORDER
} from "../types";

const initialState = {
    isLoading: false,
    success: false,
    failed: false,
    invalidRequest: false,
    invalidCustomerID: false,
    invalidWalletOwnerId: false,
    invalidAmount: false,
    accountNotExists: false,
    insufficientAmount: false,
    invalidIntegration: false,
    invalidTelcc: false,
    invalidPhone: false,
    invalidName: false,
    operationNotPermitted: false,
    data: {},
    message: ""
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_PAY_ORDER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: {},
                message: ""
            };
        case PAY_ORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: ""
            };
        case PAY_ORDER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Pay Order failed"
            };
        case PAY_ORDER_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: true,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Request"
            };
        case PAY_ORDER_INVALID_CUSTOMER_ID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: true,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Customer ID"
            };
        case PAY_ORDER_INVALID_WALLET_OWNER_ID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: true,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Wallet Owner ID"
            };
        case PAY_ORDER_INVALID_AMOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: true,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Amount"
            };
        case PAY_ORDER_ACCOUNT_NOT_EXISTS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: true,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Account Does Not Exist"
            };
        case PAY_ORDER_INSUFFICIENT_AMOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: true,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Insufficient Amount"
            };
        case PAY_ORDER_INVALID_INTEGRATION:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: true,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Integration"
            };
        case PAY_ORDER_INVALID_TELCC:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: true,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Country Code"
            };
        case PAY_ORDER_INVALID_PHONE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: true,
                invalidName: false,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Phone Number"
            };
        case PAY_ORDER_INVALID_NAME:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: true,
                operationNotPermitted: false,
                data: action.payload,
                message: "Invalid Name"
            };
        case PAY_ORDER_OPERATION_NOT_PERMITTED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidCustomerID: false,
                invalidWalletOwnerId: false,
                invalidAmount: false,
                accountNotExists: false,
                insufficientAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                invalidPhone: false,
                invalidName: false,
                operationNotPermitted: true,
                data: action.payload,
                message: "Operation Not Permitted"
            };
        case RESET_PAY_ORDER:
            return (state = initialState);

        default:
            return state;
    }
};
